var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"country-filter-by-continent"},[_c('base-select',{attrs:{"data-testid":"filter-by-region","no-option-item":{ id: null, name: 'Filter by Region' },"selected":_vm.filter.region,"options":_vm.regions},on:{"change":_vm.filterByRegion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }